import SocialList from 'components/SocialList';

import { useAuth } from 'providers/AuthProvider';
import { NavLink } from 'react-router-dom';

export default function Footer(props) {
    const menuItems = [
        { 'label': 'cégeknek', 'external': true, 'path': 'https://www.humaniahrsgroup.hu/szolgaltatasaink' },
        { 'label': 'impresszum', 'path': 'impresszum'},
        { 'label': 'adatkezelés', 'path': '/adatvedelem' },
    ];

    const { userData, setUserData } = useAuth();

    return (
        <div className={'h-auto lg:h-20 px-4 py-8 flex flex-col lg:flex-row gap-6 items-center text-white ' + (props.className || '')}>

            <div className='lg:flex-1 flex items-center justify-start order-2 lg:order-1'>
                <img onClick={() => setUserData(!userData)} className='w-36 opacity-50' src='/assets/images/logo/logo_white.svg' alt='Fürge Diák Iskolaszövetkezet' />
            </div>

            <div className='lg:flex-1 flex items-center justify-center gap-6 order-1 lg:order-2'>
                {menuItems.map((item) => <MenuItem key={item.label} data={item} />)}
            </div>

            <div className='lg:flex-1 flex items-center justify-end order-3'>
                <SocialList />
            </div>

        </div>
    );
}

function MenuItem(props) {
    if (props.data.external) {
        return (
            <NavLink 
                to={props.data.path} 
                target="_blank" 
                rel="noopener noreferrer" 
                className={'text-sm whitespace-nowrap active:scale-95 transition ' + (props.data.className || '')}
            >
                {props.data.label}
            </NavLink>
        );
    }
    return (
        <NavLink to={props.data.path} className={'text-sm whitespace-nowrap active:scale-95 transition ' + (props.data.className || '')}>
            {props.data.label}
        </NavLink>
    );
}